import "../css/main.css";
import Navbar from "../components/Navbar";

function Experience() {
    return (
        <div>
            {/* Nav Bar */}
            <Navbar></Navbar>
        </div>
    );
}

export default Experience;